function EnableBonusIcon() {
    return (
        <svg height="24" width="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34" fill="none">
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g id="check_x5F_alt"> <path d="M16,0C7.164,0,0,7.164,0,16s7.164,16,16,16s16-7.164,16-16S24.836,0,16,0z M13.52,23.383 L6.158,16.02l2.828-2.828l4.533,4.535l9.617-9.617l2.828,2.828L13.52,23.383z" fill="#00bd46"></path> </g> </g> </g>
        </svg>
    );
};

export default EnableBonusIcon;
